module.exports = __webpack_public_path__ + "images/category_lp/watch_samples/a01_pc_942c937d01bdbf74f8b0a76ff37f5fb1.png";